import React from "react";

// Animated abstract data-network hero background.
// Nodes pulse, connecting lines draw themselves. No photography, no clichés.
// Aligns to the brief: subtle, continuous, purposeful motion.

const nodes = [
  { x: 120, y: 110, r: 3, delay: 0 },
  { x: 260, y: 200, r: 4, delay: 0.6 },
  { x: 190, y: 380, r: 3, delay: 1.4 },
  { x: 400, y: 150, r: 4, delay: 2.1 },
  { x: 520, y: 290, r: 5, delay: 0.9 },
  { x: 440, y: 460, r: 3, delay: 3.0 },
  { x: 660, y: 190, r: 3, delay: 1.8 },
  { x: 780, y: 340, r: 4, delay: 2.6 },
  { x: 900, y: 210, r: 3, delay: 0.3 },
  { x: 1040, y: 320, r: 4, delay: 3.4 },
  { x: 1130, y: 140, r: 3, delay: 1.2 },
];

const links = [
  [0, 1], [1, 2], [1, 3], [3, 4], [2, 5], [4, 5], [4, 6], [3, 6],
  [6, 7], [5, 7], [7, 8], [8, 9], [6, 8], [8, 10], [9, 10],
];

export const AnimatedHero = ({ className = "" }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 1200 600"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      preserveAspectRatio="xMidYMid slice"
    >
      <defs>
        <pattern id="hero-grid" width="48" height="48" patternUnits="userSpaceOnUse">
          <path d="M 48 0 L 0 0 0 48" fill="none" stroke="currentColor" strokeOpacity="0.08" strokeWidth="1" />
        </pattern>
        <pattern id="hero-dots" width="24" height="24" patternUnits="userSpaceOnUse">
          <circle cx="1" cy="1" r="1" fill="currentColor" fillOpacity="0.14" />
        </pattern>
        <radialGradient id="hero-glow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#D65A1C" stopOpacity="0.10" />
          <stop offset="100%" stopColor="#D65A1C" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* Base grid — subtle */}
      <rect width="1200" height="600" fill="url(#hero-grid)" />

      {/* Drifting dot layer for depth */}
      <g className="anim-drift">
        <rect x="600" y="0" width="600" height="600" fill="url(#hero-dots)" />
      </g>

      {/* Radial glow behind the cluster */}
      <circle cx="640" cy="300" r="360" fill="url(#hero-glow)" className="anim-pulse-slow" />

      {/* Structural rectangles — enterprise vibe */}
      <g stroke="currentColor" strokeOpacity="0.12" strokeWidth="1" fill="none">
        <rect x="80" y="80" width="72" height="72" />
        <rect x="220" y="180" width="280" height="72" />
        <rect x="540" y="140" width="72" height="72" />
        <rect x="880" y="140" width="72" height="72" />
        <rect x="80" y="360" width="72" height="72" />
        <rect x="1000" y="280" width="72" height="72" />
      </g>

      {/* Connection lines — animated draw */}
      <g stroke="#D65A1C" strokeWidth="1" fill="none">
        {links.map(([a, b], i) => (
          <line
            key={i}
            x1={nodes[a].x}
            y1={nodes[a].y}
            x2={nodes[b].x}
            y2={nodes[b].y}
            className="anim-line"
            style={{ animationDelay: `${(i * 0.35) % 6}s`, opacity: 0.55 }}
          />
        ))}
      </g>

      {/* Nodes — pulsing */}
      <g fill="#D65A1C">
        {nodes.map((n, i) => (
          <circle
            key={i}
            cx={n.x}
            cy={n.y}
            r={n.r}
            className="anim-node"
            style={{ animationDelay: `${n.delay}s` }}
          />
        ))}
      </g>

      {/* Larger halo rings around a couple of key nodes */}
      <g fill="none" stroke="#D65A1C" strokeWidth="1">
        <circle cx={nodes[4].x} cy={nodes[4].y} r="14" className="anim-pulse-slow" style={{ animationDelay: "0.4s" }} />
        <circle cx={nodes[7].x} cy={nodes[7].y} r="12" className="anim-pulse-slow" style={{ animationDelay: "2.6s" }} />
      </g>
    </svg>
  );
};
